import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import { ExternalCoachAction } from 'bundles/ai-coach-platform/components/patterns/chat/ExternalCoachAction';
import CoachDisclosure from 'bundles/ai-coach-platform/components/patterns/disclosure/CoachDisclosure';
import { getCoachSearchQueries } from 'bundles/search-v2/components/experiments/coachInSearch/coachSearchQueries';
import { coachAdditionalContext, coachConfig } from 'bundles/search-v2/components/experiments/coachInSearch/constants';

import _t from 'i18n!nls/search';

type Props = {
  query: string;
  setCoachOpen: (open: boolean) => void;
};

export const SearchCoachDisclosure = ({ query, setCoachOpen }: Props) => {
  const disclosureVisibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_coach',
    {
      coachViewType: 'view_coach_disclosure',
      coach: {
        mode: coachConfig.coachModeId,
      },
    }
  );

  const handleClick = () => {
    setCoachOpen(true);
  };

  const lowercasedQuery = query.toLowerCase();
  const coachCaptionAndCtas = getCoachSearchQueries()[lowercasedQuery];
  const coachTriggerButtons = coachCaptionAndCtas?.ctas
    ? coachCaptionAndCtas.ctas.map((cta) => (
        <ExternalCoachAction
          key={cta}
          label={cta}
          message={cta}
          newSessionOnClick={true}
          variant="secondary"
          onClick={handleClick}
          isDisclosureButton={true}
          config={{ ...coachConfig }}
          additionalContext={[{ ...coachAdditionalContext }]}
        />
      ))
    : [];

  return coachCaptionAndCtas ? (
    <CoachDisclosure
      actionButtons={coachTriggerButtons}
      defaultExpanded
      collapsible={false}
      ref={disclosureVisibilityTrackingRef}
    >
      <Typography2 component="p">{_t('Need help exploring more learning options?')}</Typography2>
    </CoachDisclosure>
  ) : null;
};
